export const duration = {
  none: '0ms',
  instant: '100ms',
  fast: '150ms',
  base: '250ms',
  slow: '400ms',
  slower: '600ms',
}
export const easing = {
  standard: 'cubic-bezier(0.4, 0, 0.2, 1)',
  decelerate: 'cubic-bezier(0, 0, 0.2, 1)',
  accelerate: 'cubic-bezier(0.4, 0, 1, 1)',
  linear: 'cubic-bezier(0, 0, 1, 1)',
}
export const transition = {
  hover: '100ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
  enter: '250ms cubic-bezier(0, 0, 0.2, 1) 0ms',
  exit: '150ms cubic-bezier(0.4, 0, 1, 1) 0ms',
  overlay: '400ms cubic-bezier(0, 0, 0.2, 1) 0ms',
}
